import { useTranslation } from "react-i18next";
import PageLayout from "@/components/feature/PageLayout";
import { useLang } from "@/lib/useLang";
import { DOWNLOADS } from "@/data/pages";

export default function DownloadsPage() {
  const { t } = useTranslation();
  const lang = useLang();
  const d = DOWNLOADS[lang];
  const mailto = `mailto:${d.request.email}?subject=${encodeURIComponent(d.request.subject)}`;

  return (
    <PageLayout eyebrow="RESOURCES" title={t("downloads.title")} desc={d.intro}>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          {d.items.map((it) => (
            <div key={it.title} className="flex gap-4 p-5 rounded-lg bg-background-100 border border-background-200">
              <div className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${it.icon} text-lg`}></i>
              </div>
              <div>
                <div className="font-heading font-semibold text-foreground-950 mb-1">{it.title}</div>
                <p className="text-sm text-foreground-600 leading-relaxed">{it.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <aside className="lg:col-span-4">
          <div className="lg:sticky lg:top-28 p-6 rounded-lg bg-foreground-950 text-background-50">
            <h3 className="font-heading font-bold text-lg mb-2">{d.request.title}</h3>
            <p className="text-sm text-foreground-300 leading-relaxed mb-5">{d.request.desc}</p>
            <a
              href={mailto}
              className="flex items-center justify-center gap-2 w-full px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-send-line"></i>
              {d.request.button}
            </a>
            <p className="mt-3 text-xs text-foreground-400 break-all">{d.request.email}</p>
          </div>
        </aside>
      </div>
    </PageLayout>
  );
}
